"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function GlobalError({ reset }: { reset: () => void }) {
  const { back } = useRouter();

  useEffect(() => back(), [back]);
  return (
    <html lang="es">
      <body>
        <h2>Something went wrong!</h2>
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>
  );
}
